export default {
    dashboard: {
        totalWordsGenerated: 'Parole totali generate',
        wordsPerDay: 'Parole/giorno',
        content: 'Contenuto',
        date: 'Appuntamento',
        variationCount: 'Conteggio di variazione',
        transactionId: 'ID della transazione',
        totalWordsCount: 'Conteggio totale delle parole',
        action: 'Azione',
        goTo: 'vai a',
        viewMore: 'Visualizza di più',
        showLess: 'Mostra meno',
        tabImage: 'Immagine',
        tabText: 'Testo',
        dashboardSubtitle: "Gestisci i tuoi contenuti generati dall'IA",
        type: 'Tipo',
    },
};
